import React from 'react';

import { SkeletonImage, SkeletonBody } from '@xingternal/skeleton';

import styles from './Skeleton.css';

const AboutUsSkeleton = () => (
  <>
    <div className={styles.imageWrapper}>
      <SkeletonImage variant="primary" size="medium" className={styles.image} />
    </div>
    <div className={styles.pagination}>
      <SkeletonBody variant="primary" amountRows={1} />
    </div>
    <div className={styles.description}>
      <SkeletonBody variant="primary" amountRows={3} />
    </div>
  </>
);

export default AboutUsSkeleton;
